module.exports = __webpack_public_path__ + "success-ani.cff96f558ccecff5d03a7aec739a2efe.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/components/GettingStarted/success-ani.svg
// module id = 1895
// module chunks = 8